@if (notifications) {
  <div>
    @for (notification of notifications; track notification) {
      <div class="row">
        <div class="col-12">
          <ebs-notification [severityLevel]="notification.severity" [alertMessage]="notification.message"></ebs-notification>
        </div>
      </div>
    }
  </div>
}